import cx from 'classnames';
import {isInteger, isNil} from 'lodash';
import {useCallback, useMemo} from 'react';

import {FormControlProps, Input} from 'components';

import './styles.scss';
import {InputNumberControl} from './InputNumberControl';

type Props = {
    min?: number;
    max?: number;
    value: number;
    className?: string;
    onChange: (value: number) => void;
} & Partial<FormControlProps>;

export const InputNumberWithControls: React.FC<Props> = ({value, min, max, className, onChange, ...rest}) => {
    const hasMinValue = useMemo(() => !isNil(min), [min]);
    const hasMaxValue = useMemo(() => !isNil(max), [max]);

    const handleValueChange = useCallback((val: number) => {
        if (isInteger(val)) {
            if (hasMinValue && val < min) {
                return;
            } else if (hasMaxValue && val > max) {
                return;
            }
            onChange(val);
        }
    }, [min, max, hasMinValue, hasMaxValue, onChange]);

    const handleInputChange = useCallback((val: string) => {
        handleValueChange(+val);
    }, [handleValueChange]);

    return (
        <div className={cx(className, 'tw-flex tw-items-center')}>
            <InputNumberControl
                disabled={hasMinValue && value <= min}
                iconName='minus'
                className='tw-mr-2'
                onChange={() => handleValueChange(--value)}
            />
            <Input
                {...rest}
                type='number'
                className='input-number tw-w-16 tw-mb-6 tw-mx-2'
                value={value.toString()}
                onChange={handleInputChange}
            />
            <InputNumberControl
                disabled={hasMaxValue && value >= max}
                iconName='plus'
                className='tw-ml-2'
                onChange={() => handleValueChange(++value)}
            />
        </div>
    );
};